import React from 'react';
import PropTypes from 'prop-types';

import { Checkbox, Panel, Typography } from '../../components/base';

const SwitchPanel = props => {
  return (
    <Panel borderColor="orange" className={props.className}>
      <Typography.Heading size={2} mb={3}>
        {props.title}
      </Typography.Heading>
      <Checkbox
        switchId={props.title}
        mt={1}
        mb={3}
        checked={props.checked}
        onChange={props.onChange}
      >
        {props.description}
      </Checkbox>
    </Panel>
  );
};

SwitchPanel.propTypes = {
  checked: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.string,
};

export default SwitchPanel;
